import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { FormLabel, GridLegacy } from "@mui/material";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import ImageUuids from "../../Producten/ImageUuids";

export default function Media() {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Card>
        <CardBody>
          <GridLegacy container spacing={1}>
            <GridLegacy container item lg={6} xs={12}>
              <GridLegacy item xs={12}>
                <h3>
                  <TranslationWrapper tDefault={"Media"} tKey={"vestigingen.form.media.headers.media"} />
                </h3>
              </GridLegacy>
              <GridLegacy item xs={12}>
                <FormLabel>
                  <TranslationWrapper
                    tDefault={"Afbeelding(en)"}
                    tKey={"producten.form.branding.afbeelding.label.imgid"}
                  />
                </FormLabel>
                <ImageUuids fileType={"file"} />
              </GridLegacy>
            </GridLegacy>
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}
